import Axios from 'axios';
import { useEffect } from 'react';

export const httpInterceptor = Axios.create({
  baseURL: process.env.REACT_APP_API_URL + process.env.REACT_APP_API_URI
});

function HttpManagement(props) {
  const setRequest = config => {
    config.headers['content-Type'] = 'application/json';
    config.headers['Access-Control-Allow-Origin'] = '*';
    return config;
  };

  const printToConsoleError = (message, error) => {
    console.error(
      `error HttpManagement url: ${error.config.method?.toUpperCase()} ${
        error.config.baseURL
      }${error.config.url}`
    );
    if (error.response && error.response.data.error) {
      const responseData = error.response.data.error;
      console.error(`error HttpManagement message: ${responseData.message}`);
    }
  };

  const httpResponseHandling = response => {
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      // CALL HTTP HANDLE ERROR
      console.error('Error connect service');
    }
  };

  const httpErrorHandling = error => {
    let message;
    if (
      error?.response?.statusText === 'Internal Server Error' &&
      error?.response?.status === 500
    ) {
      message = `Internal server error`;
      printToConsoleError(message, error);
      throw message;
    }

    if (
      error?.response?.statusText === 'Not Found' &&
      error?.response?.status === 404
    ) {
      message = `SERVICE NOT FOUND`;
      printToConsoleError(message, error);
      throw message;
    }
    if (
      error?.response?.statusText === 'Unprocessable Entity' &&
      error?.response?.status === 422
    ) {
      message = `MIN LENGTH`;
      printToConsoleError(message, error);
      throw message;
    }

    throw error;
  };

  useEffect(() => {
    httpInterceptor.interceptors.request.use(config => setRequest(config));
    httpInterceptor.interceptors.response.use(
      res => httpResponseHandling(res),
      error => httpErrorHandling(error)
    );
  }, []);

  return props.children;
}

export default HttpManagement;
